import { useState } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    Button,
    Image,
    Card,
    Popover,
    OverlayTrigger,
} from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import stdnt from "../assets/images/student.png";
import schl from "../assets/images/school.png";
import hsptl from "../assets/images/hospital.png";
import sign_img from "../assets/images/sign_img.png";
import { BsFillCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { MdChecklist, MdOutlineAutoGraph, MdOutlineHelp } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { showErrorMessage, showSuccessMessage } from "../services/utils";
const ForgotPassword = () => {
    const BaseURL = process.env.REACT_APP_BASE_URL

    const { type } = useParams()
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState(false)

    function submitEmail(e) {
        e.preventDefault()
      const body={
        email:email,
        role:type.toLowerCase()
      }
        setEmail("")
        try{
            setLoading(true)
            axios.post(`${BaseURL}forgotUserPassword`,body).then(res=>{
                showSuccessMessage({message:"E-mail sent successfully"})
            })
            .catch((error)=>{
            console.log(error,"<<<gdfrhgyfd")

                showErrorMessage({message:error.response.data.errors.msg})
            })
            setLoading(false)
            

        }catch(error){
            setLoading(false)
            console.log(error)
            

        }

    }

    return (
        <div className="signup_pg">
            <Container fluid>
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Forgot Password?</h2>
                                    <p>
                                        Enter your registered email address and
                                        we'll send a password reset link on your
                                        email
                                    </p>
                                </div>
                                <Form className="signform_div" onSubmit={(e)=>(submitEmail(e))}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword"
                                    >
                                        <Form.Label>
                                            Registered Email address
                                        </Form.Label>
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            placeholder="Enter Registered Email address"
                                            onChange={(e) => (setEmail(e.target.value))}
                                        />

                                        <Button
                                            className="btn_theme w-100 mt-4"
                                            type="submit"
                                            variant=""
                                            
                                        >
                                            Continue
                                        </Button>
                                    </Form.Group>

                                    {/* <p className="sign_agree">
                                        By signing up, you are indicating that
                                        you have read and agree to the{" "}
                                        <a href="#" className="bld_link">
                                            Terms of Use
                                        </a>{" "}
                                        and{" "}
                                        <a href="#" className="bld_link">
                                            Privacy Policy
                                        </a>
                                        .
                                    </p> */}



                                    <p className="sign_agree text-center mt-2">
                                        <Link to="/signin">
                                            Back to Log In
                                        </Link>

                                    </p>
                                </Form>
                            </div>
                        </Col>
                        <Col md={6} className="pe-0 sticky_col">
                            <div className="signuprt_div">
                                <div className="sign_logo mb-5">
                                    <a href="/">
                                        <Image src={Logo} fluid />
                                    </a>
                                </div>
                                <div className="sign_img">
                                    <Image src={sign_img} fluid />
                                </div>
                                <div className="wb_ftrs">
                                    <ul>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <MdOutlineAutoGraph />
                                                </span>
                                                <span>
                                                    Streamlined and High
                                                    efficiency
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <MdChecklist />
                                                </span>
                                                <span>
                                                    Organized and Comprehensive
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <HiOutlineClipboardCheck />
                                                </span>
                                                <span>
                                                    HIPAA and FERPA Compliant
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default ForgotPassword;
